module.exports = __webpack_public_path__ + "static/media/purchase-white.cfd303bc.svg";